import React from "react";
import IndexNavbar from "components/Navbars/IndexNavbar";

const ZipLockPrivacy = () => {
  React.useEffect(() => {
    document.body.classList.add("index-page");
    document.body.classList.add("sidebar-collapse");
    document.documentElement.classList.remove("nav-open");
    window.scrollTo(0, 0);
    document.body.scrollTop = 0;
    return function cleanup() {
      document.body.classList.remove("index-page");
      document.body.classList.remove("sidebar-collapse");
    };
  }, []);

  const headingStyle = { fontSize: "22px", fontWeight: "600", color: "#222", marginTop: "30px" };
  const textStyle = { fontSize: "16px", fontWeight: "400", color: "#444", lineHeight: "1.8", marginTop: "10px" };
  const smallTextStyle = { fontSize: "14px", fontWeight: "400", color: "#666" };

  return (
    <>
      <IndexNavbar />
      <div className="wrapper">
        <div className="main">
          <div className="section section-basic" style={{ paddingTop: "120px" }}>
            <div className="container" style={{ maxWidth: "900px" }}>
              <h1 style={{ fontSize: "32px", fontWeight: "700", color: "#111", textAlign: "center" }}>
                Privacy Policy
              </h1>
              <p style={{ ...smallTextStyle, textAlign: "center", marginTop: "10px" }}>
                Ziipper Lock - BUGUN SOFTWARE COMPANY LIMITED
              </p>

              <div style={{ marginTop: "40px" }}>
                <h3 style={headingStyle}>1. Introduction</h3>
                <p style={textStyle}>
                  BUGUN SOFTWARE COMPANY LIMITED ("we", "our", or "us")
                  operates the Ziipper Lock Android application ("App"). This
                  Privacy Policy explains how we collect, use, and protect your
                  information when you use our App.
                </p>

                <h3 style={headingStyle}>2. App Functionality</h3>
                <p style={textStyle}>
                  Ziipper Lock uses the "Display over other apps" permission
                  to show a zipper animation overlay at the top of your screen.
                  This feature allows users to personalize their device
                  experience by displaying a zipper-style visual effect above
                  other applications.
                </p>
                <p style={textStyle}>
                  The overlay is purely visual and does not monitor, record, or
                  interact with the content of other applications on your
                  device.
                </p>

                <h3 style={headingStyle}>3. Permissions We Use</h3>
                <ul style={{ ...textStyle, paddingLeft: "20px" }}>
                  <li style={{ marginTop: "8px" }}>
                    <strong>Display over other apps:</strong> Required to show
                    the zipper effect on top of the screen.
                  </li>
                </ul>
                <p style={textStyle}>
                  We only request permissions necessary for the App to function
                  properly.
                </p>

                <h3 style={headingStyle}>4. Information Collection</h3>
                <p style={textStyle}>
                  Ziipper Lock does not collect personal information such as
                  name, email address, phone number, or contacts.
                </p>
                <p style={textStyle}>
                  We do not access, store, or share the content displayed in
                  other apps while the overlay is active.
                </p>

                <h3 style={headingStyle}>5. Data Sharing</h3>
                <p style={textStyle}>
                  We do not sell, trade, or share your personal data with third
                  parties. Since we do not collect personal data, no personal
                  information is shared.
                </p>

                <h3 style={headingStyle}>6. Security</h3>
                <p style={textStyle}>
                  We are committed to ensuring that the App operates securely.
                  As no personal data is collected, risks related to personal
                  data exposure are minimized.
                </p>

                <h3 style={headingStyle}>7. Children’s Privacy</h3>
                <p style={textStyle}>
                  Ziipper Lock does not knowingly collect personal information
                  from children under the age of 13. If you believe a child has
                  provided personal information, please contact us so we can
                  take appropriate action.
                </p>

                <h3 style={headingStyle}>8. Changes to This Policy</h3>
                <p style={textStyle}>
                  We may update this Privacy Policy from time to time. Any
                  changes will be posted on this page with an updated effective
                  date.
                </p>

                <h3 style={headingStyle}>9. Contact Us</h3>
                <p style={textStyle}>
                  If you have any questions about this Privacy Policy, please
                  contact:
                </p>
                <p style={textStyle}>
                  <strong>Company Name:</strong> BUGUN SOFTWARE COMPANY LIMITED
                </p>
                <p style={textStyle}>
                  <strong>Email:</strong> thanglvan@gmail.com
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ZipLockPrivacy;